export const paragraphs = [
  'Whenever I compare myself to other people who suffer from the disability I consider myself lucky.',
  'I noticed that my reading abilities took a turn for the worse.',
  'Often when I write a word or sentence down I switch some letters without noticing.',
  'It can take up to ten seconds before realizing what’s actually wrong.',
  'It’s too hard to recognize the shapes from one another.',
  'I prefer to read on a sheet of paper as it’s quite sad for the trees.',
  'I might be slower with finishing it then others but that doesn’t bother me at all.',
  'Stuttering and making mistakes when I am reading out loud are a few things I struggle with.',
  'Sometimes I switch the letters within a word and notice it too late.',
  'I was running behind in reading class, as I couldn’t get past a certain reading level.',
  'As a reward they would read me one or two in return.',
  'My brain can’t handle processing tons of information for long periods of time.',
  'It’s just something I have rather than something that I am.',
  'These two go hand in hand as the one stimulates the other and vice versa.',
  'Although I like to read books, I would prefer using a screen to read something.',
  'I guess our generation is more used to this kind of technology.',
  'I mostly struggle with certain language rules in my mother tongue.',
  'It’s difficult to know how many repetition of letters are in a singular word.',
  'I always need to think twice about it before I write anything down.',
  'They start jumping up and down and making it difficult to read properly.',
  'It mostly affects my self-confidence and that of course leads to bigger problems.',
  'Reading out loud in front of people scares me a lot.',
  'I am scared that they will think I am weird.',
  'My spelling has improved quite a bit as I make less and less mistakes.',
  'I make spelling mistakes on a regular basis and only realize it afterwards.',
  'I always need to proofread everything, which can take a long time and be tedious for me.',
  'I have more difficulty when several weights are combined, such as regular, bold and italic.',
  'As far as the characters go, I would prefer a sans serif over a monospaced typeface.',
  'There has been some significant improvement since my diagnosis.',
  'I guess I was very lucky to get the diagnosis on an early age.',
  'Letters are moving around, quite freely, so it really slows down my ability to read fast.',
  'Mostly this is with long words, something very typical for dyslexia.',
  'My brain cannot distinguish long words from each other for some odd reason.',
  'It’s apparently a known phenomenon that it always skips a generation.',
  'A screen makes some letters “dance” a bit more than on paper.',
  'I make a lot of mistakes and start pronouncing words incorrectly.',
  'Without her I would have never been able to read and write at the age of six.',
  'I always had problems with reading, writing and spelling since I was a child.',
  'Reading in front of class was extremely difficult and I often felt embarrassed.',
  'This problem is not language-related because I always have it when I read or write.',
  'When I have to read something for the first time I read very slowly.',
  'I have the tendency to write everything down in a phonetical way.',
  'When I’m reading something on a screen I need to focus more than I do on paper.',
  'When I was younger other people would laugh at me so I am scared it will happen again.',
  'As long as I can remember I’ve struggled with it.',
  'Occasionally, I read the same word twice or I write double letters.',
  'Although having dyslexia is quite the struggle it also has a few advantages.',
  'It has been proven that we can solve visual situations better.',
  'It has its advantages in the artistic or scientific disciplines.',
  'Many teachers were quite skeptical about everything and didn’t want to help.',
  'It helps me to put my finger next to the lines so I don’t lose sight of where I am.',
  'I still keep struggling with spelling but I manage quite well these days.',
  'I write words as I think it would be written and guess how they are build up.',
  'It can be quite frustrating at times and slows down the process.',
  'Whenever it’s too small it’s difficulties to recognize the shapes.',
  'It definitely helpt in understanding my position in the world.',
  'That being someone to whom reading and writing didn’t come easy to.',
  'This might seem simple but it takes away a lot of confusion that I had before.',
  'Normally when you build a skill there is a natural progression.',
  'This however was never the case with reading or at least it seemed that way.',
  'Letters inside a word flip continuously, which is messing with my mind.',
  'I have to read it twice in order to see what is actually there.',
  'The biggest problem I have is with writing and not necessarily with reading.',
  'An ability that gives me a better understanding of reading and writing.',
  'I don’t actually read the words, I only read the message in order to save time.',
  'After a while it resulted in a low self-esteem and a lack of confidence.',
  'I read a lot slower, but most people don’t read so I still get more done.',
  'Looking at habits I definitely prefer bigger sans-serif with a lot of open space.',
  'I didn’t want to be confronted with my own incompetence and stupidity.',
  'The only way I could however, was to read these books.',
  'Now here’s the thing about copywriters, they actually know how to write.',
  'They place rhythm in their writing and they engage you.',
  'Leave enough white space between paragraphs so your eyes don’t go crazy.',
  'Keep the sentences short and don’t use words that haven’t been spoken aloud for centuries.',
  'For the first time I could actually read books.',
  'For the first time I felt as if I could actually write.',
  'It’s not just a lack of reading and such, but an entire different way of processing something.',
  'I believe the our brain sees everything as a whole, as a dynamic or a rhythm.',
  'Whilst looking at specific and individual shapes, things get complicated really fast.',
  'That way I’ll know which letter comes first and which one must be before that and so on.',
  'When I saw the mistakes she made, I noticed similarities.',
  'In the eyes of many I was a bad student and was often told that I was stupid.',
  'I don’t find things easily and then it takes a while before I finish my work.',
  'That’s why I prepare my texts very well and ensure that I learn many things by heart.',
  'The less I have to look at the paper, the faster it goes.',
  'I have the impression that the letters are sometimes influenced by the luminous background.',
  'It gives me the impression that the letters are slightly stretched out.',
  'Taking a book spontaneously is not something I do on a regular basis.',
  'If I had received help in the past I would have had less trouble with it today.',
  'I tend to switch letters in a word and I have trouble with aligning a strong baseline.',
  'It looks like the letters start to dance when I am trying to read something.',
  'It messes with my brain and I struggle to complete or reading something quickly.',
  'This is maybe because the typesetting is different or the size is generally quite small.',
  'You learn some tricks along the way and you manage to control it.',
  'I’ll pack up quickly, re-read the sentence and then it goes smooth.',
  'Now I know how to handle certain situations quite well.',
  'I’ve managed to control the disability and not the other way around.',
  'As an adult I don’t make the same mistake any more as I used to make when I was younger.',
  'It often feels like words shift places which makes it difficult to make sense of it all.',
  'For over twenty years I’ve been struggling with writing things down.',
  'Words are hard to recognize so I have to take it step by step.',
  'I’ve been laughed at a lot and was often labeled stupid by teachers.',
  'Speaking in front of others is no major problem but reading is horrible.',
  'I never really had good marks for my language classes and it didn’t improve over time.',
  'If the typeface is simple and quite clear then it’s easier to read it fluently.',
  'When there are too many curls or it looks unbalanced it’s hard to recognize the shapes.',
  'I like to read on my own with no stress and at my own pace.',
  'Whenever I read something, I have trouble with recognizing what is written down.',
  'The content or meaning of a text changes because I swap several words in a sentence.',
  'I lack a good insight on how a certain word is constructed and recreate a new one entirely.',
  'Spaces in between disappear and sometimes I no longer see the beginning and end of a word.',
  'Despite the fact that I still struggle a lot, I was well guided and got enough help.',
  'My brain skips or ignores pieces when I read which makes the entire content unreadable.',
  'Having something in your hands is much more stable to me.',
  'I have to repeat them or have to write them down later.',
  'It’s uncomfortable when I have to speak in another language as I struggle a bit with that.',
  'Sometimes I feel very uncomfortable when I have to speak or read in another language.',
  'You feel that it’s not going smooth and notice that others notice it too.',
  'I actually use it as a motivation and work harder than usual.',
  'It caused a breach into my self-confidence and I had to work very hard in general.',
  'Carrying out my profession with great passion',
  'There will always remain an eternal struggle.',
  'Every time I blink it looks like they go from the left to the right and vice versa.',
  'Working with children that had some difficulties with reading, writing and spelling.',
  'I have a tendency to change letters and then the construction doesn’t make sense anymore.',
  'Afterwards the texts were discussed in class with everyone.',
  'It’s difficult to process sometimes and maybe that’s why I don’t read books in my spare time.',
  'Whenever I read a sentence I guess the words before I actually read them.',
  'A combination of certain words turn into a similar one that would fit into the context.',
  'I often repeat sentences as I don’t fully understand them.',
  'The things I struggled with are still there and haven’t reduced.',
  'I can’t concentrate when I drive, too much is happening on the left and right.',
  'Never thought of it this way but I do have trouble with the spacing.',
  'When I’m reading I often make the mistake of starting wrongly when I finish a sentence.',
  'You learn to live with it and over time you develop strategies that help you.',
  'Concentration is often hard to find and I just can’t find the time for it.',
  'My mind can’t keep up and loses track of how all those words are set up.',
  'I keep switching them and don’t know when to use which.',
  'After a while I stopped because it had improved to a level that was acceptable.',
  'I started to pass tests but I never really improved and just had to learn the words by heart.',
  'This took away the pleasure of reading and changed the way I cope with languages.',
  'When I was diagnosed it really felt like a weight fell off my shoulders.',
  'It affects my life but I don’t try to let it worry me that much.',
  'I usually space and enlarge a bit of the spacing and compare the lining to other designers.',
  'The spacing continuously moves from wide too narrow and visa versa.',
  'Finding a letter in the alphabet, the order of the letters are still a mystery.',
  'Reading or writing a long text didn’t make any sense to me.',
  'She always surrounded us with books and encouraged us to read.',
  'Reading became a pleasure and wasn’t an obligation.',
  'I don’t consider dyslexia as having a disability or handicap.',
  'When driving on the highway I get confused reading the signs.',
  'On a daily basis I make a lot of spelling mistakes and my writing is quite slow.',
  'In every case I have the feeling that I can get used to an “uncomfortable” typeface.',
  'Serifs don’t have a big influence on my reading ability.',
  'Surprisingly, I quite like monospaced fonts for reading.',
  'A book is worse when the printing consists of bad quality.',
  'Reading a lot helped me to read better generally.',
  'If you train and become better in one skill, you lose performance in something else.',
  'I don’t seem to recognize the words in the way they are written down.',
  'I have a lot of difficulties with the correct pronunciation of accents.',
  'I have to concentrate on every word I read or write.',
  'I find it harder to read white letters on a black background.',
  'If you pronounce a word wrongly, it’s hard to read it out loud.',
  'Swapping words in a sentence to such a degree that it doesn’t make sense any more.',
  'Whenever someone checks if I made errors they always find a lot of them.',
  'Reading in serif is easier because the letters are already connected.',
  'Definitely not comfortable with reading and struggle with gaps in orthography.',
  'Performing in an emergency situation paralyzes me, sort to speak.',
  'It can be difficult to manage my emotions to be honest.',
  'A frequent boredom and loneliness that makes me question certain things.',
  'It very uncomfortable to read something on the computer.',
  'I quickly realized that the more I read the easier it became to maintain it.',
  'Things have changed and evolved in a good way and it continues to do so.',
];
